import React from 'react';
import { AdminLayout } from '../adminLayout';
import AnalyticsDashboard from '../Analytics/analytics';

const AdminDashboard = () => {
  return (
    <AdminLayout pageTitle="Dashboard Overview" activeTab="dashboard">
      <div>
        <AnalyticsDashboard />
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
